module.exports = __webpack_public_path__ + "img/frase_balao_3.a1dc6202.svg";